import React, { useState, useEffect } from 'react';
import { adminbannerAPI } from '../../Handlers/adminbannerAPI';
import { productAPI } from '../../Handlers/productAPI';
import BannerCard from '../../components/cards/BannerCard';
import EditBannerForm from '../../components/forms/EditBannerForm';
import CreateModal from '../../components/modals/createModal';

function BannerList() {
    const [banners, setBanners] = useState([]);
    const [products, setProducts] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [slotToEdit, setSlotToEdit] = useState(null);

    const fetchData = async () => {
        try {
            const [bannerRes, productRes] = await Promise.all([
                adminbannerAPI.getAll(),
                productAPI.getAll()
            ]);
            setBanners(bannerRes);
            setProducts(productRes);
        } catch (error) {
            console.error("Erro ao carregar dados dos banners:", error);
        }
    };

    useEffect(() => { fetchData(); }, []);

    const onEdit = (slotIndex) => {
        // Busca o banner existente ou cria um objeto temporário com a ordem correta
        const existingBanner = banners.find(b => b.order === slotIndex) || {
            order: slotIndex,
            image: null,
            product_id: ''
        };
        setSlotToEdit(existingBanner);
        setShowEditModal(true);
    };

    return (
        <div className="container">
            <h1>Gerenciar Banners (Homepage)</h1>
            <div className="banner-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
                {[1, 2, 3].map(slot => {
                    const data = banners.find(b => b.order === slot);
                    return (
                        <BannerCard
                            key={slot}
                            slot={slot}
                            banner={data}
                            onEdit={() => onEdit(slot)}
                        />
                    );
                })}
            </div>

            {showEditModal && (
                <CreateModal
                    isOpen={showEditModal}
                    onClose={() => setShowEditModal(false)}
                    title={`Editar Banner - Slot ${slotToEdit?.order}`}
                >
                    <EditBannerForm
                        banner={slotToEdit}
                        products={products}
                        onSuccess={() => {
                            fetchData();
                            setShowEditModal(false);
                        }}
                    />
                </CreateModal>
            )}
        </div>
    );
}

export default BannerList;